import React, { useState } from 'react';
import '../style/NewsCards.css';
import hondacity from '../assets/hondacity.webp';
import zrv from '../assets/hondazrv.png';
import sierraEV from '../assets/sierraev.png';
import tesla from '../assets/teslamodely.png';
const newsData = [
  {
    index: "01",
    title: "Tesla Model Y L (6-Seater) Launched in India",
    lead: "Tesla introduces a long-wheelbase Model Y with 3-row seating and extended range, targeting premium family buyers.",
    image: tesla,
    date: "APRIL 2026",
    link: "https://www.tesla.com/en_in/modely"
  },
  {
    index: "02",
    title: "Honda City Facelift 2026 Launch ",
    lead: "Updated sedan arrives with ventilated seats, larger screens, and hybrid tech, launched on May 22.",
    image: hondacity,
    date: "MAY 2026",
    link: "https://www.hondacarindia.com/honda-city"
  },
  {
    index: "03",
    title: "Honda ZR-V Hybrid SUV Set for India Debut",
    lead: "Premium hybrid SUV with 2.0L e:HEV powertrain and 180+ hp targets the high-end SUV segment.",
    image: zrv,
    date: "MAY 2026",
    link: "https://www.hondacarindia.com/"
  },
  {
    index: "04",
    title: "Tata Sierra EV & Safari EV Near Launch",
    lead: "Tata prepares to launch next-gen electric SUVs with modern design and long-range capabilities.",
    image: sierraEV,
    date: "MAY 2026",
    link: "https://ev.tatamotors.com/"
  }
];

const NewsCards = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 2;
  const currentCards = newsData.slice((currentPage - 1) * cardsPerPage, currentPage * cardsPerPage);
  const totalPages = Math.ceil(newsData.length / cardsPerPage);

  return (
    <section className="classy-news-section">
      <div className="editorial-header">
        <span className="eyebrow">The CarsChalao Digest</span>
        <h2 className="editorial-title">LATEST INSIGHTS</h2>
      </div>

      <div className="editorial-feed">
        {currentCards.map((news, idx) => (
          <div className="editorial-card" key={idx}>
            <div className="editorial-image-box">
              <span className="floating-index">{news.index}</span>
              <img src={news.image} alt={news.title} className="editorial-img" />
            </div>

            <div className="editorial-content">
              <div className="content-inner">
                <span className="editorial-date">{news.date}</span>
                <h3 className="editorial-headline">{news.title}</h3>
                <p className="editorial-lead">{news.lead}</p>
                <a href={news.link} className="editorial-cta">
                  READ ARTICLE
                  <span className="cta-line"></span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="editorial-pagination">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
          &larr; PREVIOUS
        </button>
        <div className="page-numbers">
          {Array.from({ length: totalPages }, (_, i) => (
            <span key={i} className={currentPage === i + 1 ? 'active' : ''}>{i + 1}</span>
          ))}
        </div>
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>
          NEXT &rarr;
        </button>
      </div>
    </section>
  );
};

export default NewsCards;